import React from "react";

const TenantContext = React.createContext();

export default TenantContext;
